import { buildFilter } from '@platform/core/lib/filterDsl';
import type { IListViewState, IRecordListParams, IRecordTypeDefinition } from '@platform/core/types';
import { quickFilterDsl } from './quickFilter';

/**
 * Параметри статистики для лічильника варіанта швидкого фільтра `quick` у множині `domain` (фільтр і пресет сторінки-списку; без неї — увесь
 * тип, як «Фільтр» сторінки модуля прототипу). Варіант додається умовами фільтр-DSL (quickFilterDsl), пресет — лише множини; «Усі» без
 * множини — порожні параметри, той самий запит, що й лічильники меню (спільний кеш). Чиста функція.
 */
export function quickCountParams(
  quick: IListViewState['quickFilter'], rt: IRecordTypeDefinition, domain: Pick<IRecordListParams, 'filter' | 'preset'> = {},
): IRecordListParams {
  const filter = buildFilter([domain.filter, quickFilterDsl(quick, rt)]);
  return { ...(filter ? { filter } : {}), ...(domain.preset ? { preset: domain.preset } : {}) };
}
